import { useEffect, useMemo, useState } from "react";
import { deadlinePhase, remainingMs, serverOffsetMs } from "@/lib/paymentDeadline";

/**
 * Phase 4C — satu implementasi countdown 1 detik (display only). Dipakai hanya di detail pesanan.
 * Offset = order.server_now - jam perangkat saat response diterima; tidak ada request per detik.
 */
export function usePaymentCountdown(order) {
  const offset = useMemo(() => serverOffsetMs(order?.server_now), [order?.server_now]);
  const [nowMs, setNowMs] = useState(() => Date.now() + offset);
  const ticking = ["active", "warning"].includes(deadlinePhase(order, nowMs));

  useEffect(() => { setNowMs(Date.now() + offset); }, [offset, order?.payment_deadline]);
  useEffect(() => {
    if (!ticking) return undefined;
    const id = setInterval(() => setNowMs(Date.now() + offset), 1000);
    return () => clearInterval(id);
  }, [ticking, offset]);

  const phase = deadlinePhase(order, nowMs);
  return { phase, remainingMs: remainingMs(order, nowMs), nowMs };
}
